import React from 'react'
import styles from './Status.module.scss'

const Status = () => <span className={styles.root}>Status</span>

export default Status
